export const baseUrl = "https://atci.lkm.eitacademy.accenture.com/ips-apis";
export const lttbaseUrl = 'https://atci.lkm.accenture.com/lttmicrosite-apis';
export const imageBaseUrl =
  "https://atci.lkm.eitacademy.accenture.com/eit-images";
